<template>
  <div class="selectBatch">
    <!-- 添加按钮 -->
    <div class="addCredit" @click="show_add_box = true">
      <van-icon name="plus" size="0.36rem" />
    </div>
    <van-overlay :show="show_add_box" @click="show_add_box = false" z-index="3">
      <div class="show_add_box" @click.stop>
        <span @click="toAddBatch">新增库存</span>
        <span @click="toAddSurcharge">新增附加费</span>
      </div>
    </van-overlay>

    <!-- 搜索 -->
    <!-- <div class="search_bar">
      <van-search
        v-model="listQuery.name"
        show-action
        placeholder="请输入商品名字进行搜索"
        @search="onSearch"
        v-if="active_tab == 1"
      >
        <template slot="action">
          <div @click="onSearch"> 搜 索 </div>
        </template>
      </van-search>
      <van-search
        v-model="listQuery_2.name"
        show-action
        placeholder="请输入附加费名字进行搜索"
        @search="onSearch_2"
        v-if="active_tab == 2"
      >
        <template slot="action">
          <div @click="onSearch_2"> 搜 索 </div>
        </template>
      </van-search>
    </div>-->
    <!-- 下拉选择 -->
    <div class="dropdownMenu">
      <van-tabs v-model="active_tab" color="#31B158" width="40" @change="changeTab">
        <van-tab title="库存" name="1"></van-tab>
        <van-tab title="附加费" name="2"></van-tab>
      </van-tabs>
    </div>
    <!-- 列表 -->
    <div class="part1">
      <van-sidebar v-model="menuIndex" v-show="active_tab == 1">
        <van-sidebar-item
          v-for="(item,i) in goodsTypeList"
          :key="i"
          :title="item.name"
          @click="changeMenuIndex(i)"
        />
      </van-sidebar>
      <div class="list list1" v-show="active_tab == 1"  style="height: calc(100vh - 1.76rem);overflow-y:auto">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getList"
               
          >
          <!--  style="height: calc(100vh - 1.76rem);overflow-y: auto;" -->
          <div class="goods_list">
            <div
              class="item"
              v-for="(item,index) in list"
              :key="index"
              @click="toChangeGoods(item,1)"
            >
              <div class="c_item item_box">
                <div class="item_line item_line_1">
                  <div class="item_name van-ellipsis">{{item.name}}</div>
                  <div class="item_type">
                    <span class="item_type_zy" v-if="item.type == 1">自营</span>
                    <span class="item_type_dm" v-else>代卖</span>
                  </div>
                </div>
                <div class="item_line item_line_1">
                  <div class="item_weight van-ellipsis" v-if="item.bale != 1 && item.bale != 2">
                    库存：<span
                      :style="Number(item.last_total)<0?'color:#f00':'color:#31B158'"
                    >{{item.last_total*1}}</span> 公斤
                  </div>
                  <div class="item_weight van-ellipsis" v-if="item.bale == 1">
                    库存：<span
                      :style="Number(item.last_total)<0?'color:#f00':'color:#31B158'"
                    >{{item.last_total_num*1}}</span>
                    {{unit_list[item.num_unit-1].name}}
                  </div>
                  <div class="item_weight van-ellipsis" v-if="item.bale == 2">
                    库存：<span
                      :style="Number(item.lase_num)<0?'color:#f00':'color:#31B158'"
                    >{{item.lase_num - 0}}</span>{{unit_list[item.num_unit-1].name}}  
                  </div>
                </div>
                <!-- <div class="item_shipper van-ellipsis">货主：{{item.supplier.name}}</div> -->
              </div>
            </div>
          </div>
          <!-- <div style="height:0.5rem"></div> -->
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!-- 列表2 -->
    <div class="list" v-show="active_tab != 1">
      <van-pull-refresh v-model="refreshing_2" @refresh="onRefresh_2" style="min-height:100%">
        <van-list
          v-model="loading_2"
          :finished="finished_2"
          finished-text="没有更多了"
          @load="getList_2"
        >
          <div class="goods_list">
            <div
              class="item"
              v-for="(item,index) in list_2"
              :key="index"
              @click="toChangeGoods(item,2)"
            >
              <div class="f_item item_box">
                <div class="item_name van-ellipsis">{{item.name}}</div>
                <div
                  class="item_price van-ellipsis"
                >{{item.price}}{{item.type == 1?'元/个':'元'}} {{item.type == 1?" x "+(item.num-0)+'个':''}}</div>
              </div>
            </div>
          </div>
          <div style="height:0.5rem"></div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 输入规格数量 -->
    <van-action-sheet
      v-model="showGoodsNum"
      :close-on-click-overlay="false"
      @closed="keyOnClose"
      @open="resetKey = true"
    >
      <div class="good_num_box" id="good_num_box" v-if="resetKey">
        <div class="good_title_box">
          <div class="van-ellipsis" style="font-size: 0.36rem;    line-height: 0.6rem;    padding: 0 0.5rem 0 0;    padding-bottom: 0;    color: #333;    font-weight: bold;">{{input_active_goods.name}}</div>
          <div
            style="flex-shrink: 0;"
          >
            <div class="good_type good_type_0" v-if="input_active_goods.bale == 3">
              散装
              <img src="./../../../assets/img/work/open_order/order/type_sanzhuang.png" alt />
            </div>
            <div class="good_type good_type_1" v-if="input_active_goods.bale == 1">
              定装
              <img src="./../../../assets/img/work/open_order/order/type_dingzhuang.png" alt />
            </div>
            <div class="good_type good_type_2" v-if="input_active_goods.bale == 2">
              非定装
              <img src="./../../../assets/img/work/open_order/order/type_feidingzhuang.png" alt />
            </div>
            <div class="good_type good_type_3" v-if="input_active_goods.goods_type == 2">
              附加费
              <img src="./../../../assets/img/work/open_order/order/type_fujiafei.png" alt />
            </div>
          </div>
          <div class="good_box_close" @click="showGoodsNum = false">
            <van-icon name="cross" size="0.4rem" />
          </div>
        </div>
        <div class="good_content_box" style="width:100%;box-sizing:border-box;">
          <div class="good_item_wn" style="width:100%" v-if="input_active_goods.goods_type == 1">
            <div class="good_des_box" style="width:100%">
              <div>批次号：{{input_active_goods.batch}}</div>
              <div
                v-if="input_active_goods.bale == 1"
              >规格：{{input_active_goods.bale_num}} 公斤/{{unit_list[input_active_goods.num_unit-1].name}}</div>
            </div>
             <div style="display: flex;justify-content: space-between;align-items: center;width:100%;margin-bottom:0.15rem;">
                <div class="van-ellipsis" style="max-width:40%;">货主：{{input_active_goods.supplier.name}}</div> 
                <div class="van-ellipsis" style="max-width:60%;">
                  <div class="item_line item_line_1">
                    <div class="item_weight van-ellipsis" v-if="input_active_goods.bale != 1 && input_active_goods.bale != 2">
                      库存：<span
                        :style="Number(input_active_goods.last_total)<0?'color:#f00':'color:#31B158'"
                      >{{input_active_goods.last_total*1}}</span> 公斤
                    </div>
                    <div class="item_weight van-ellipsis" v-if="input_active_goods.bale == 1">
                      库存：<span
                        :style="Number(input_active_goods.last_total)<0?'color:#f00':'color:#31B158'"
                      >{{input_active_goods.last_total_num*1}}</span>
                      {{unit_list[input_active_goods.num_unit-1].name}}
                    </div>
                    <div class="item_weight van-ellipsis" v-if="input_active_goods.bale == 2">
                      库存：
                      <span
                          :style="Number(input_active_goods.lase_num)<0?'color:#f00':'color:#31B158'"
                        >{{input_active_goods.lase_num - 0}}</span>{{unit_list[input_active_goods.num_unit-1].name}} (<span
                        :style="Number(input_active_goods.last_total)<0?'color:#f00':'color:#31B158'"
                      >{{input_active_goods.last_total*1}}</span>公斤)
                    </div>
                  </div>
                </div>
             </div>
            <!-- 数量 -->
            <div
              class="good_item_input_box"
              v-if="input_active_goods.bale == 1 || input_active_goods.bale == 2"
            >
              <KeyBoardInput
                :k_default_show="focus_key_board == 'num'"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.num"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">数量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">{{unit_list[input_active_goods.num_unit-1].name}}</div>
                </template>
              </KeyBoardInput>
            </div>
            <!-- 重量 -->
            <div
              class="good_item_input_box"
              v-if="input_active_goods.bale == 2 || input_active_goods.bale == 3"
            >
              <KeyBoardInput
                :k_default_show="focus_key_board == 'weight'"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.weight"
                :k_decimal="3"
              >
                <template slot="input_left">
                  <div class="input_left">重量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">公斤</div>
                </template>
              </KeyBoardInput>
            </div>
            <!-- 单价 -->
            <div class="good_item_input_box">
              <KeyBoardInput
                :k_default_show="focus_key_board == 'price'"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_decimal="2"
                :k_placeholder="input_active_goods.proposed_price>0?input_active_goods.proposed_price:''"
              >
                <template slot="input_left">
                  <div class="input_left">单价</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">
                    <div
                      v-if="input_active_goods.bale == 1"
                    >元/{{unit_list[input_active_goods.num_unit-1].name}}</div>
                    <div v-if="input_active_goods.bale == 4">元/个</div>
                    <div v-if="input_active_goods.bale == 2 || input_active_goods.bale == 3">元/公斤</div>
                  </div>
                </template>
              </KeyBoardInput>
            </div>
          </div>
          <div class="good_item_wn" v-else>
            <div class="good_item_input_box" v-if="input_active_goods.type == 1">
              <KeyBoardInput
                :k_default_show="focus_key_board == 'num'"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.num"
                :k_placeholder="Number(input_active_goods.num)"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">数量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">个</div>
                </template>
              </KeyBoardInput>
            </div>
            <div class="good_item_input_box" v-if="input_active_goods.type == 1">
              <KeyBoardInput
                :k_default_show="focus_key_board == 'price'"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
                :k_isNegative="input_active_goods.price<0"
              >
                <template slot="input_left">
                  <div class="input_left">单价</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">元/个</div>
                </template>
              </KeyBoardInput>
            </div>
            <div class="good_item_input_box" v-if="input_active_goods.type != 1">
              <KeyBoardInput
                :k_default_show="focus_key_board == 'price'"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
                :k_isNegative="input_active_goods.price<0"
              >
                <template slot="input_left">
                  <div class="input_left">金额</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">元</div>
                </template>
              </KeyBoardInput>
            </div>
          </div>
        </div>
        <!-- 使用一个假的键盘占个位置 -->
        <div class="fake_div">
          <div class="fake_confim">
            <button type="button" class="van-key van-key--large" @touchstart="keyOnConfirm">完成</button>
          </div>
          <div class="van-key__wrapper"></div>
          <van-number-keyboard
            style="position: relative;"
            :show="true"
            :transition="false"
            :extra-key="['AC','.']"
            close-button-text="完成"
            theme="custom"
            z-index="1"
          ></van-number-keyboard>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import {  goods_list } from "@/api/work/manage/goodsManage.js";
import {
  baseGoods_list,
  baseSurcharge_list,
  ws_url,goods_type_list
} from "@/api/work/order/openOrder";
const modelMenuList = [
  { name: "全部", id: "" },
  // { name: "未分类", id: 0 }
];
export default {
  name: "selectBatch",
  components: {
    KeyBoardInput
  },
  data() {
    return {
      menuIndex: 0, //商品分类索引0
      goodsTypeList: modelMenuList,
      show_add_box: false,
      pack_list: [
        { value: 1, name: "定装" },
        { value: 2, name: "非定装" },
        { value: 3, name: "散装" }
      ],
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      active_tab: "1",
      // 库存
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery: {
        page: 1,
        pageSize: "15",
        type: 2,
        name: "",
        status: "1"
      },

      listGoodsQuery: {
        cate_id: "",
        name: "",
         page: 1,
        pageSize: "50",
      },

      // 附加费
      list_2: [],
      loading_2: false,
      finished_2: false,
      refreshing_2: false,
      listQuery_2: {
        page: 1,
        pageSize: "15",
        name: ""
      },

      // 修改规格参数
      input_active_goods: "",
      showGoodsNum: false,
      resetKey: false,
      keyValue: "",
      keyData: {
        name: "",
        batch: "",
        bale_num: "",
        num_unit: "",
        unit: "",
        type: "",
        goods_type: "",
        weight: "",
        bale: "",
        num: "",
        price: ""
      },

      // 聚焦键盘
      focus_key_board: ""
    };
  },
  created() {
    if (this.$route.meta.backData) {
      delete this.$route.meta.backData;
    }
    this.getList();
    this.getMenuList();
    this.getList_2();
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "manage_stock_addStock") {
        this.listQuery.page = 1;
        this.getList();
      }
      if (from.route.name == "manage_sale_addExtraFee") {
        this.listQuery_2.page = 1;
        this.getList_2();
      }
    });
  },
  mounted() {},
  methods: {
    //得到商品分类列表
    getMenuList() {
      goods_type_list().then(res => {
        if (res.code == 200) {
          // if(!res.data[0].items)
          // {
          //   res.data[0].items=[]
          // };
          // this.list = res.data[0].items;
          this.goodsTypeList = res.data.map(item=>{
            let obj={
              name:item.name,
              id:item.cate_id
            }
            return obj
          });
        }
      });
    },
    changeMenuIndex(index) {
      this.menuIndex = index;
      this.listGoodsQuery.cate_id = this.goodsTypeList[index].id;
      this.listGoodsQuery.page=1;
      this.list=[];
      this.getList();
    },

    // 点击了搜索按钮
    onSearch() {
      // this.$toast(this.listQuery.search)
      this.listQuery.page = 1;
      this.getList();
    },

    // 第一个按钮
    // 获取列表
    getList() {
      goods_list(this.listGoodsQuery).then(res => {
        if (res.code == 200) {
          if(this.listGoodsQuery.page == 1) this.list = []
          this.list = this.list.concat(res.data.list)
          if(this.list.length == res.data.totalCount || res.data.list.length == 0){
              this.finished = true;
          }else{
              this.loading = false
              this.finished = false;
              this.listGoodsQuery.page++;
          }
          this.refreshing = false;
        }
      });
      // baseGoods_list(this.listQuery).then(res=>{
      //   if(res.code == 200 ){
      //       if(this.listQuery.page == 1) this.list = []
      //       this.list = this.list.concat(res.data.list)
      //       if(this.list.length == res.data.totalCount || res.data.list.length == 0){
      //           this.finished = true;
      //       }else{
      //           this.loading = false
      //           this.listQuery.page++
      //       }
      //       this.refreshing = false;
      //   }
      // })
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1
      this.listGoodsQuery.page=1;
      this.getList();
    },

    // 点击了搜索按钮
    onSearch_2() {
      this.listQuery_2.page = 1;
      this.getList_2();
    },
    // 获取列表
    getList_2() {
      baseSurcharge_list(this.listQuery_2).then(res => {
        if (res.code == 200) {
          if (this.listQuery_2.page == 1) this.list_2 = [];
          this.list_2 = this.list_2.concat(res.data.list);
          if (
            this.list_2.length == res.data.totalCount ||
            !res.data.list ||
            res.data.list.length == 0
          ) {
            this.finished_2 = true;
          } else {
            this.loading_2 = false;
            this.listQuery_2.page++;
          }
          this.refreshing_2 = false;
        }
      });
    },
    // 下拉刷新
    onRefresh_2() {
      // 清空列表数据
      this.finished_2 = false;
      this.refreshing_2 = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading_2 = true;
      this.listQuery_2.page = 1;
      this.getList_2();
    },

    // 选择附加费
    toChangeFee(item) {
      this.$route.meta.backData = JSON.stringify(item);
      this.$router.go(-1);
    },

    // tab 切换
    changeTab(name, title) {
      // console.log(name)
    },

    /**
     * 修改规格相关
     */
    toChangeGoods(item, goods_type) {
      this.resetKey = true;
      this.input_active_goods = JSON.parse(JSON.stringify(item));
      var good = this.input_active_goods;
      this.input_active_goods.goods_type = goods_type + "";
      this.keyData.name = this.input_active_goods.name;
      this.keyData.batch = this.input_active_goods.batch;
      this.keyData.bale_num = this.input_active_goods.bale_num;
      this.keyData.num_unit = this.input_active_goods.num_unit;
      this.keyData.type = this.input_active_goods.type;
      this.keyData.goods_type = goods_type + "";
      this.keyData.bale = this.input_active_goods.bale;
      this.keyData.weight = "";
      this.keyData.num = "";
      this.keyData.price = "";
      this.showGoodsNum = true;
      if (good.goods_type == 1 && (good.bale == 1 || good.bale == 2)) {
        this.focus_key_board = "num";
      }
      if (good.goods_type == 1 && good.bale == 3) {
        this.focus_key_board = "weight";
      }
      if (good.goods_type == 2 && good.type == 1) {
        this.focus_key_board = "num";
      }
      if (good.goods_type == 2 && good.type == 2) {
        this.focus_key_board = "price";
      }
    },

    keyOnConfirm() {
      var good = this.input_active_goods;
      if (good.goods_type == 2) {
        // this.keyData.weight = this.keyData.weight===""?good.weight +'':this.keyData.weight
        // this.keyData.bale = good.bale
        this.keyData.num =
          Number(this.keyData.num === "" ? good.num + "" : this.keyData.num) +
          "";
        this.keyData.price =
          this.keyData.price === ""
            ? Math.abs(good.price) + ""
            : this.keyData.price;
      }
      if (good.goods_type == 1) {
        this.keyData.price =
          this.keyData.price === ""
            ? Number(good.proposed_price) + ""
            : this.keyData.price;
      }
      if (
        this.input_active_goods.goods_type == 1 &&
        this.input_active_goods.bale == 1 &&
        !(this.keyData.num > 0)
      ) {
        this.$toast("请输入商品销售数量！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 1 &&
        this.input_active_goods.bale == 2 &&
        !(this.keyData.num > 0)
      ) {
        this.$toast("请输入商品销售数量！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 1 &&
        this.input_active_goods.bale == 2 &&
        !(this.keyData.weight > 0)
      ) {
        this.$toast("请输入商品销售重量！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 1 &&
        this.input_active_goods.bale == 3 &&
        !(this.keyData.weight > 0)
      ) {
        this.$toast("请输入商品销售重量！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 1 &&
        !(this.keyData.price > 0)
      ) {
        this.$toast("请输入销售单价！");
        return false;
      }

      if (
        this.input_active_goods.goods_type == 2 &&
        this.input_active_goods.type == 1 &&
        !(this.keyData.num > 0)
      ) {
        this.$toast("请输入附加费销售数量！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 2 &&
        this.input_active_goods.type == 1 &&
        !(this.keyData.price >= 0)
      ) {
        this.$toast("请输入附加费单价！");
        return false;
      }
      if (
        this.input_active_goods.goods_type == 2 &&
        this.input_active_goods.type == 2 &&
        !(this.keyData.price >= 0)
      ) {
        this.$toast("请输入附加费金额！");
        return false;
      }
      let i = this.input_active_order_index,
        i_g = this.input_active_goods_index;
      if (this.input_active_goods.bale == 1) {
        this.keyData.weight = Number(
          (Number(this.keyData.num) * Number(good.bale_num)).toFixed(3)
        );
      } else {
        this.keyData.weight = Number(this.keyData.weight);
      }

      var keyData = JSON.parse(JSON.stringify(this.keyData));
      keyData.price =
        good.price < 0 && keyData.price > 0
          ? -this.keyData.price
          : this.keyData.price;
      var t_price = 0;
      if (this.input_active_goods.goods_type == 1) {
        if (this.input_active_goods.bale == 1) {
          t_price = (keyData.price * keyData.num).toFixed(2);
        } else {
          t_price = (keyData.price * keyData.weight).toFixed(2);
        }
      } else {
        if (this.input_active_goods.type == 1) {
          t_price = (keyData.price * keyData.num).toFixed(2);
        } else {
          t_price = (keyData.price * 1).toFixed(2);
        }
      }
      new Audio(
        "http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=" +
          this.input_active_goods.name +
          "，" +
          t_price +
          "元"
      ).play();
      this.$route.meta.backData = JSON.stringify(keyData);
      this.$router.go(-1);
    },
    // 关闭事件
    keyOnClose() {
      this.keyData = {};
      this.resetKey = false;
    },

    // 去添加批次
    toAddBatch() {
      this.show_add_box = false;
      this.$router.push({
        path: "/manage/stock/addStock"
      });
    },
    // 去添加附加费
    toAddSurcharge() {
      this.show_add_box = false;
      this.$router.push({
        path: "/manage/sale/addExtraFee"
      });
    }
  }
};
</script>
<style lang="less">
.selectBatch {
  .van-sidebar {
    height: calc(100vh - 1.76rem);
    // position: fixed;
    // bottom: 0;
    // z-index:100;
    background: #fff;
    overflow-y: auto;
    flex-grow: 0;
    flex-shrink: 0;
    width: 1.3rem;
    .van-sidebar-item {
      font-size: 0.28rem;
      height: 1.2rem;
      padding: 0 0.15rem;
      box-sizing: border-box;
      text-align: center;
      color: #666666;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
    }
    // .van-sidebar-item:nth-last-child(1) {
    //   color: #31b158;
    // }
    .van-sidebar-item--select {
      color: rgb(49,177,88);
      font-weight: bold;

      background: #f5f5f5;
    }

    //  .van-sidebar-item--select:active
    .van-sidebar-item--select::before {
      background-color: transparent;
    }
  }
}
</style>
<style lang="less" scoped>
.selectBatch {
  position: relative;

  .addCredit {
    position: fixed;
    top: 0;
    width: 0.88rem;
    height: 0.88rem;
    right: 0.1rem;
    z-index: 99;
    font-size: 0.32rem;
    color: #31b158;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .show_add_box {
    box-sizing: border-box;
    position: absolute;
    top: 1.03rem;
    right: 0.15rem;
    width: 2.3rem;
    height: 1.61rem;
    padding: 0 0.15rem;
    background-color: #fff;
    border-radius: 0.1rem;
    span {
      line-height: 0.8rem;
      text-align: center;
      display: block;
      font-size: 0.28rem;
      color: #000;
      &:nth-child(1) {
        border-bottom: 0.01rem solid #ccc;
      }
    }
  }
  .search_bar {
    position: sticky;
    top: 0;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .dropdownMenu {
    position: sticky;
    top: 0.88rem;
    z-index: 2;
    // box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }

  .list {
    position: relative;
    .goods_list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 0.3rem 0 0.3rem;
      .item {
        width: 3.35rem;
        margin: 0.15rem 0 0;
        border-radius: 0.1rem;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0 0.16rem;
        font-size: 0.28rem;
        .item_box {
          font-size: 0.3rem;
          color: #999;
          line-height: 0.4rem;
          padding-bottom: 0.1rem;
          .item_line {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .item_name {
            width: 2.2rem;
            font-size: 0.36rem;
            margin-top: 0.1rem;
            line-height: 0.5rem;
            color: #333;
            font-weight: bold;
          }
          .item_type {
            font-size: 0.24rem;
            width: 0.7rem;
            text-align: center;
            height: 0.3rem;
            line-height: 0.3rem;
            margin: 0.08rem 0;
            span {
              display: inline-block;
              width: 0.7rem;
              text-align: center;
              height: 0.3rem;
              border-radius: 0.06rem;
            }
            .item_type_zy {
              background: rgba(28, 192, 233, 0.3);
              color: #268ea7;
            }
            .item_type_dm {
              background: rgba(233, 153, 28, 0.3);
              color: #c6601c;
            }
          }
          .item_price {
            margin-top: 0.15rem;
          }
        }
      }
    }
  }

  .list1 {
    height: calc(100vh - 1.76rem);
    padding: 0 0 0 0rem;
    box-sizing: border-box;
    flex-shrink: 1;
    width: 6.2rem;
  }
  .part1{
      display: flex;
  }
  .part1 .list {
  

    .goods_list {
      padding-left: 0.2rem;
      .item {
        width: 2.75rem;
      }
    }
  }

  // 键盘
  .good_num_box {
    position: relative;
    background-color: #f2f3f5;
    .good_title_box {
      font-size: 0.36rem;
      line-height: 0.6rem;
      padding: 0.2rem 1rem 0 0.2rem;
      padding-bottom: 0;
      color: #333;
      font-weight: bold;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      div {
        font-size: 0.28rem;
        color: #999;
        font-weight: normal;
        margin-left: 0.1rem;
      }
      .good_box_close {
        position: absolute;
        right: 0.3rem;
        top: 0.2rem;
        z-index: 2;
      }
    }
    .good_content_box {
      padding: 0 0.3rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .good_des_box {
        // padding-bottom: 0.15rem;
      }
      .good_item_wn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .good_item_input_box {
        width: 100%;
        height: 0.88rem;
        line-height: 0.84rem;
        border: 0.02rem solid #ccc;
        padding: 0 0.15rem;
        margin-bottom: 0.2rem;
        box-sizing: border-box;
        border-radius: 0.1rem;
        .good_item_input {
          flex: auto;
          overflow: hidden;
          height: 0.84rem;
          margin: 0 0.1rem;
          padding-right: 0.05rem;
          position: relative;
          text-align: right;
          font-size: 0.32rem;
          font-weight: bold;
          background-color: transparent;
        }
      }
    }
    .good_type {
      padding: 0 0.18rem;
      height: 0.4rem;
      line-height: 0.4rem;
      border-radius: 0.2rem;
      &.good_type_0 {
        background-color: #dafbdb;
        color: #4b9c64;
      }
      &.good_type_1 {
        background-color: #daeffb;
        color: #1d78c5;
      }
      &.good_type_2 {
        background-color: #fbedda;
        color: #bf8535;
      }
      &.good_type_3 {
        background-color: #fbe1da;
        color: #bf1535;
      }
      img {
        width: 0.22rem;
        height: 0.22rem;
        margin-left: 0.1rem;
      }
    }
  }
  .fake_div {
    position: relative;
    .fake_confim {
      position: absolute;
      right: 6px;
      z-index: 999;
      bottom: 6px;
      width: calc((100% - 6px) / 4 - 6px);
      height: calc(50% - 12px);
      background-color: #31b158;
      border-radius: 8px;
      button {
        background-color: #31b158;
        color: #fff;
        font-size: 0.42rem;
      }
    }
  }
  // 键盘结束
}
</style>

<style lang="less">
.selectBatch{
  .van-pull-refresh .van-list{
    padding-bottom: 0;
  }
}
</style>